export default "__VITE_ASSET__BLi2W2RE__"